import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": ".8",
      d: "M.963 3.262v11.27H9.27M3.958.268h8.427v3.66"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": ".8",
      d: "M3.958.268v2.994H.963M3.958.268.963 3.262M11.229 12.528a3.808 3.808 0 1 0 0-7.616 3.808 3.808 0 0 0 0 7.616"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": ".8",
      d: "M11.792 12.486c.216.899.355 2.038.355 2.331a.914.914 0 1 1-1.83 0c0-.293.139-1.432.355-2.33M11.432 8.72h-.403a.733.733 0 1 1 0-1.466h.403c.405 0 .733.328.733.733M11.03 8.72h.402a.733.733 0 1 1 0 1.467h-.403a.733.733 0 0 1-.733-.733M11.232 10.852v-.667M11.232 7.253v-.667"
    }, null, -1)
  ])))
}
export default { render: render }